import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Button,
  Text,
} from '@razorpay/blade/components';

interface SaveDraftAndCloseModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const SaveDraftAndCloseModal: React.FC<SaveDraftAndCloseModalProps> = ({
  isOpen,
  onCancel,
  onContinue,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onCancel}
      size="small"
      accessibilityLabel="Changes Saved as Draft">
      <ModalHeader title="Changes Saved as Draft" />

      <ModalBody>
        <Text size="medium" color="surface.text.gray.normal">
          Your progress has been saved as a draft. You can safely leave and continue from the People
          section anytime
        </Text>
      </ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="tertiary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onContinue}>
            Continue
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}; 